// Librerias
import React from 'react'
import api from '../../apiClient/v1'
let PropTypes = React.PropTypes
// ReactNotify
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
// Componentes
import { TablaPersonal } from './TablaPersonal.jsx'
import { ModalTrigger, ModalAgregarUsuario } from './Modales.jsx'

export class MantenedorPersonal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            usuariosRAW: [],
            usuarios: [],
            comunas: [],
            bancos: [],
            busquedaComuna: '',
            busquedaRUN: '',
            busquedaNombre: '',
            busquedaApellido: '',
            busquedaCaptador: '',
            busquedaVigencia: '',
            searchStatusContract: '',
            idDocumentationState: 0
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4*1000);
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
        this.nuevoUsuario = (datos)=>{
            let request = api.usuarios.nuevoUsuario(datos)
            request
                .then(resp=>{
                    this.fetchUsuarios()
                })
            return request
        }
        this.actualizarUsuario = (idUsuario, usuarioActualizado)=>{
            // fechaNacimiento viene como date, se debe convertir a texto
            let request = api.usuario(idUsuario).actualizar(usuarioActualizado)
            request
                .then(this.fetchUsuarios)// no es necesario actualizar la lista completa... pero da lo mismo
            return request
        }
        this.fetchUsuarios = ()=>{
            this.setState({
                usuariosRaw: []
            })
            let idState = this.state.idDocumentationState
            api.usuarios.fetch(idState)
                .then(usuarios=>{
                    this.setState({
                        usuariosRAW: usuarios,
                    }, this.filtrarUsuarios)
                })
        }
        this.realizarBusqueda = (campo, busquedaOriginal)=>{
            let newState = {}
            newState[campo] = busquedaOriginal.trim().toLowerCase()
            this.setState(newState, this.filtrarUsuarios)
        }
        this.filtrarUsuarios = ()=> {
            this.setState({
                usuarios: this.state.usuariosRAW
                    .filter(us=> us.RUN.indexOf(this.state.busquedaRUN)>=0)
                    .filter(us=> us.apellidoPaterno.toLowerCase().indexOf(this.state.busquedaApellido)>=0  || us.apellidoMaterno.toLowerCase().indexOf(this.state.busquedaApellido)>=0)
                    .filter(us=> us.nombre1.toLowerCase().indexOf(this.state.busquedaNombre)>=0  || us.nombre2.toLowerCase().indexOf(this.state.busquedaNombre)>=0)
                    .filter(us=> us.captador.toLowerCase().indexOf(this.state.busquedaCaptador)>=0)
                    .filter(us=> us.vigencia.toLowerCase().indexOf(this.state.busquedaVigencia)>=0)
                    .filter(us=> us.isContractFile.toLowerCase().indexOf(this.state.searchStatusContract)>=0)
                    .filter(us=> us.comuna.toLowerCase().indexOf(this.state.busquedaComuna)>=0)
            })
        }
        this.bloquearUsuario = (idUsuario)=>{
            api.usuario(idUsuario).bloquear()
                .then(this.fetchUsuarios)
        }
        this.desbloquearUsuario = (idUsuario)=>{
            api.usuario(idUsuario).desbloquear()
                .then(this.fetchUsuarios)
        }
        this.cambiarContrasena = (idUsuario, contrasena)=>{
            api.usuario(idUsuario).cambiarContrasena(contrasena)
        }
        this.verHistorial = (idUsuario)=>{
            return api.usuario(idUsuario).historial()
        }
        this.bloquearUsuarioCliente = (idUsuario, usuarioActualizado)=>{
            let request = api.usuario(idUsuario).bloquearCliente(usuarioActualizado)
            request
                .then(()=> console.log("cambio realizado"))
                .catch(meh=>{})
            return request
        }
        this.changeStatusDocumentation = (idUser, status) => {
            let request = api.usuario(idUser).changeStatusDocumentation(status)
            request
                .then(response => {
                    this.refs.notificator.success("Estado documentación", "El estado de la documentación ha cambiado", 4*1000);
                    this.fetchUsuarios()
                })
                .catch(this.ajaxErrorHandler('Error al intentar aprobar documentos de usuario'))
            return request
        }
        this.onSelectDocumentationState = (evt) => {
            this.setState({
                idDocumentationState : evt.target.value
            }, ()=>{
                this.fetchUsuarios()
            })
        }
    }    getChildContext() {
        return {
            uploadDNIFront: (idUser, file) => {
                let data = new FormData()
                data.append('DNIFront' ,file)
                let request = api.usuario(idUser).uploadPersonalFile(data)
                request
                    .then(response => {
                        this.refs.notificator.success("CARNET", "Foto frontal agregada correctamente", 4*1000);
                    })
                    .catch(this.ajaxErrorHandler('Error al subir foto frontal carnet'))
                return request
            },
            uploadDNIBack: (idUser, file) => {
                let data = new FormData()
                data.append('DNIBack' ,file)
                let request = api.usuario(idUser).uploadPersonalFile(data)
                request
                    .then(response => {
                        this.refs.notificator.success("CARNET", "Foto posterior agregada correctamente", 4*1000);
                    })
                    .catch(this.ajaxErrorHandler('Error al subir foto posterior carnet'))
                return request
            },
            uploadCertificate: (idUser, file) => {
                let data = new FormData()
                data.append('certificate' ,file)
                let request = api.usuario(idUser).uploadPersonalFile(data)
                request
                    .then(response => {
                        this.refs.notificator.success("CERTIFICADO", "Cerficado antecedentes agregado correctamente", 4*1000);
                    })
                    .catch(this.ajaxErrorHandler('Error al subir certificado antecedentes'))
                return request
            },
            uploadContract: (idUser, file) => {
                let data = new FormData()
                data.append('contract' ,file)
                let request = api.usuario(idUser).uploadPersonalFile(data)
                request
                    .then(response => {
                        this.refs.notificator.success("CONTRATO", "Contrato de trabajo agregado correctamente", 4*1000);
                    })
                    .catch(this.ajaxErrorHandler('Error al subir contrato de trabajo'))
                return request
            },
            uploadCredential: (idUser, file) => {
                let data = new FormData()
                data.append('credential' ,file)
                let request = api.usuario(idUser).uploadPersonalFile(data)
                request
                    .then(response => {
                        this.refs.notificator.success("CREDENCIAL", "Credencial agregada correctamente", 4*1000);
                    })
                    .catch(this.ajaxErrorHandler('Error al subir credencial de operador'))
                return request
            },
            progressStatusDocumentation: (idUser, status) => {
                let request = api.usuario(idUser).changeStatusDocumentation(status)
                request
                    .then(response => {
                        this.refs.notificator.success("Estado documentación", "El estado de la documentación ha cambiado", 4*1000);
                        this.fetchUsuarios()
                    })
                    .catch(this.ajaxErrorHandler('Error al intentar aprobar documentos de usuario'))
                return request
            },
            isWrongFile: (idFile, status) => {
                let request = api.documentUser(idFile).isWrongFile(status)
                request
                    .then(response => {
                        this.refs.notificator.success("Estado documento", "Ha cambiado el estado del documento", 4*1000);
                        this.fetchUsuarios()
                    })
                    .catch(this.ajaxErrorHandler('Error al intentar cambiar el estado del documento'))
                return request
            }
        }
    }    
    componentWillMount(){
        this.fetchUsuarios()
        api.otros.comunas()
            .then(comunas=>{
                this.setState({comunas})
            })
        api.otros.bancos()
        .then(bancos=>{
            this.setState({bancos})
        })
    }
    render(){
        return(
            <div>
                <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                <div className="row">
                    <div className="col-md-6">
                        <h1>Mantenedor de Personal</h1>
                    </div>
                    <div className="col-md-6">
                        <SelectStatusDoc
                            idDocumentationState = {this.state.idDocumentationState}
                            documentationStates = {this.props.documentationStatus}
                            onSelectDocumentationState = {this.onSelectDocumentationState}
                        />
                        <div className="pull-right">
                            <ModalTrigger>
                                {(isVisible, showModal, hideModal)=>
                                    <button className="btn btn-sm btn-primary" onClick={showModal}>
                                        Agregar usuario
                                        {isVisible && (
                                            <ModalAgregarUsuario
                                                hideModal={hideModal}
                                                nuevoUsuario={this.nuevoUsuario}
                                                comunas={this.state.comunas}
                                                datosbancos = {this.state.bancos}
                                                fetchUsuarios={this.fetchUsuarios}
                                            />
                                        )}
                                    </button>
                                }
                            </ModalTrigger>
                            <a className="btn btn-sm btn-success pull-right"
                               href={`/api/usuarios/exportar-excel`}
                            >Exportar</a>
                        </div>
                    </div>                  
                </div>

                <TablaPersonal
                    usuarios={this.state.usuarios}
                    comunas={this.state.comunas}
                    datosbancos = {this.state.bancos}
                    actualizarUsuario={this.actualizarUsuario}
                    bloquearUsuario={this.bloquearUsuario}
                    desbloquearUsuario={this.desbloquearUsuario}
                    cambiarContrasena={this.cambiarContrasena}
                    verHistorial={this.verHistorial}
                    bloquearUsuarioCliente={this.bloquearUsuarioCliente}
                    onApproveFiles = {this.changeStatusDocumentation}
                    perms = {this.props.perms}
                    
                    // busqueda
                    busquedaComuna={this.state.busquedaComuna}
                    realizarBusquedaComuna={this.realizarBusqueda.bind(this, 'busquedaComuna')}
                    busquedaRUN={this.state.busquedaRUN}
                    realizarBusquedaRUN={this.realizarBusqueda.bind(this, 'busquedaRUN')}
                    busquedaNombre={this.state.busquedaNombre}
                    realizarBusquedaNombre={this.realizarBusqueda.bind(this, 'busquedaNombre')}
                    busquedaApellido={this.state.busquedaApellido}
                    realizarBusquedaApellido={this.realizarBusqueda.bind(this, 'busquedaApellido')}
                    busquedaCaptador={this.state.busquedaCaptador}
                    realizarBusquedaCaptador={this.realizarBusqueda.bind(this, 'busquedaCaptador')}
                    busquedaVigencia={this.state.busquedaVigencia}
                    realizarBusquedaVigencia={this.realizarBusqueda.bind(this, 'busquedaVigencia')}
                    seachStatusContract={this.state.searchStatusContract}
                    searchingStatusContract={this.realizarBusqueda.bind(this, 'searchStatusContract')}
                    clientes={this.props.clientes}
                    fetchUsuarios={this.fetchUsuarios}
                />
            </div>
        )
    }
}
MantenedorPersonal.propTypes = {
    clientes: PropTypes.arrayOf(PropTypes.object).isRequired,
    documentationStatus: PropTypes.arrayOf(PropTypes.object).isRequired,
    perms: PropTypes.object.isRequired
}
MantenedorPersonal.childContextTypes = {
    uploadDNIFront: PropTypes.func,
    uploadDNIBack : PropTypes.func,
    uploadCertificate: PropTypes.func,
    uploadContract: PropTypes.func,
    uploadCredential: PropTypes.func,
    progressStatusDocumentation: PropTypes.func,
    isWrongFile: PropTypes.func,
}

const SelectStatusDoc = ({idDocumentationState, documentationStates, onSelectDocumentationState})=>
    <div className="dropdown col-md-offset-4 col-md-4">
        <select className="form-control"
                value={idDocumentationState}
                onChange={onSelectDocumentationState}>
            <option value="0">Filtro Documentación</option>
            {documentationStates.map((documentationState, index)=>{
                return <option key={index} value={documentationState.idDocumentationStatus}>{documentationState.name}</option>
            })}
        </select>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/admin/MantenedorPersonal/MantenedorPersonal.jsx